import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { orange, red } from "@mui/material/colors";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { useEffect } from "react";
import { deleteDeal, getAllDeals } from "../../../State/admin/DealSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number
) {
  return { name, calories, fat, carbs, protein };
}



export default function DealTable() {
  const dispatch = useAppDispatch()
  const {deal}=useAppSelector(store=>store)

  useEffect(() => { 
    // if(deal.dealCreated||deal.dealDeleted){

      dispatch(getAllDeals())
    // } 
  },[])
  const handleDelete = async(id:number|undefined) => { 
      if(id!=undefined){
        await dispatch(deleteDeal(id))
      }
   }  
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>No</StyledTableCell>
            <StyledTableCell>Image</StyledTableCell>
            <StyledTableCell>Category</StyledTableCell>
            <StyledTableCell align="right">Discount</StyledTableCell>
            <StyledTableCell align="right">Edit</StyledTableCell>
            <StyledTableCell align="right">Delete</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deal.deals.map((item,index) => (
            <StyledTableRow key={index}>
              <StyledTableCell component="th" scope="row">
                {item.id}
              </StyledTableCell>
              <StyledTableCell>
                <img className="w-20 rounded-md" src={item.category.image} alt="" />
              </StyledTableCell>
              <StyledTableCell>{item.category.name}</StyledTableCell>
              <StyledTableCell align="right">{item.discount}</StyledTableCell>
              <StyledTableCell align="right">
                <Button sx={{color:orange[500]}}>
                  <Edit />
                </Button>
              </StyledTableCell>
              <StyledTableCell align="right">
                <Button onClick={() => { handleDelete(item.id) }} sx={{color:red[500]}}>
                 <Delete/>
                </Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
